module.exports = __webpack_public_path__ + "static/media/gabinets.21bce32c.svg";